import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { ThemeService } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-newField-select-admin-config',
  templateUrl: './newField-select-admin-config.component.html',
  styleUrls: ['./newField-select-admin-config.component.scss']
})
export class AtwNewFieldSelectAdminConfig  extends AtwUpdateDbComponent  {
  @Input() objectChoosing: any;
  @Input() device: any
  @Input() class: any;
  @Input() config: any;
  @Input() type: any;
  @Input() staticdata: any;
  configMode: 'basic' | 'advanced' = 'basic'; 
  isViewAll: boolean = false;
  currentViewAll: any = {};
  lookupGroupArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  currentField: any;
  newFields = [];
  template: any;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    public themeService: ThemeService,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator

  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
   }

  ngOnInit() {
    this.getNewFileds();

    forkJoin([
      this.http.get('assets/data/objects_sample/basic/customize-newField/customize-newField-template.json'),
    ]).subscribe(([template]: any) => {
      this.template = template
    })
  }

  getNewFileds() {
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector } })
      .then((newfields: any) => {
        this.newFields = newfields;

        if (this.staticdata.field_custom) {
          this.currentField = this.newFields.find((field) => field.field_custom == this.staticdata.field_custom);
        }
      });
  }

  /**
* Hàm này dùng để cho phép mở menu config .
* Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
* @param: value
*/
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

//   /**
//  * Hàm update object vào database.
//  */
//   updateObject() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
//       .then((bool: any) => {
//         // console.log('updateObject', bool);
//       })
//   }
//   /**
//    *Hàm update class vào database.
//    */
//   updateClass() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
//       .then((bool: any) => {
//         // console.log('updateClass', bool);
//       })
//   }

//   /**
//  *Hàm update config vào database.
//  */
//   updateConfig() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
//       .then((bool: any) => {
//       })
//   }

//   /**
//  * Cập nhật staticdata vào database.
//  */
//   updateStaticData() {
//     // Gọi hàm truy vấn cơ sở dữ liệu ở đây
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
//       .then((bool) => {
//       });
//   }


  updateWidthAndHeight(newWidth: number): void {
    this.class['select__checkbox']['width'] = `${newWidth}px`;
    // Giữ tỷ lệ 1:1 (hoặc thay đổi logic tùy ý)
    this.class['select__checkbox']['height'] = `${newWidth}px`;
  }

  changeLookupGroup(event) {
    this.staticdata.lookup_group = event;
    this.updateStaticData();
  }

  onChangeFieldCustom(selectedValue: any) {
    this.currentField = this.newFields.find((field) => field.field_custom == selectedValue);
    const { field_input_location, field_input_type, field_display_type } = this.currentField

    let dataUpdate: any = {}

    if (field_input_location == 'user') {
      if (field_input_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_input_type.includes('input') || field_input_type == 'textarea') {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'input__boundary'
        }
      }

      if (field_display_type == 'text' && field_input_type == 'ckeditor') {
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'text'
        }
      }
    } else if (field_input_location == 'admin') {
      if (field_display_type.includes('select')) {
        dataUpdate = {
          resize_group: 'input',
          resize_field: 'select__boundary'
        }
      }

      if (field_display_type == 'radio') {
        // dùng group image vì group input phải có [id]="'boundary'+data._id"
        dataUpdate = {
          resize_group: 'image',
          resize_field: 'radio'
        }
      }

      if (field_display_type == 'text') {
        dataUpdate = {
          resize_group: 'text',
          resize_field: 'text'
        }

        if (field_input_type == 'ckeditor') {
          dataUpdate.resize_group = 'image'
        }
      }
    }

    dataUpdate = {
      ...dataUpdate,
      desktop_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      tablet_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_landscape_class: {
        ...this.template[dataUpdate.resize_field]
      },
      mobile_portrait_class: {
        ...this.template[dataUpdate.resize_field]
      },
      staticdata: this.staticdata
    }

        this.staticdata = this.staticdata
    this.class = {
      ...this.template[dataUpdate.resize_field]
    }
    this.objectChoosing.resize_field = dataUpdate.resize_field;
    this.objectChoosing.resize_group = dataUpdate.resize_group;
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'config-changed', 
      code: this.objectChoosing._id, 
    });


        if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('desktop_class')) this.objectChoosing['fieldUpdate'].push('desktop_class')
      if (!this.objectChoosing['fieldUpdate'].includes('tablet_landscape_class')) this.objectChoosing['fieldUpdate'].push('tablet_landscape_class')
      if (!this.objectChoosing['fieldUpdate'].includes('tablet_portrait_class')) this.objectChoosing['fieldUpdate'].push('tablet_portrait_class')
      if (!this.objectChoosing['fieldUpdate'].includes('mobile_landscape_class')) this.objectChoosing['fieldUpdate'].push('mobile_landscape_class')
      if (!this.objectChoosing['fieldUpdate'].includes('mobile_portrait_class')) this.objectChoosing['fieldUpdate'].push('mobile_portrait_class')
        
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      if (!this.objectChoosing['fieldUpdate'].includes('resize_field')) this.objectChoosing['fieldUpdate'].push('resize_field')
      if (!this.objectChoosing['fieldUpdate'].includes('resize_group')) this.objectChoosing['fieldUpdate'].push('resize_group')
      return;
    }

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, dataUpdate)
  }





}
